import { CAMPAIGN_PAGE_SUBSCRIPTIONS } from '@/store/actions/admin/campaignPageSubscriptions.actions';

const initialState = {
  subscriptions: []
};

export default function campaignPageSubscriptions(state = initialState, action) {
  switch (action.type) {
    case CAMPAIGN_PAGE_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: action.payload.data || []
      };
    default:
      return state;
  }
}
